<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-container formArrayName="products">
      @for (product of products.controls; track product; let index = $index) {
        @if (index == 0) {
          <ng-container [formGroup]="product">
            <ng-container formGroupName="parameters">
              @if (
                getAdditionalQuestions(parameters, 'CROWDFUNDING_NOMINATIF_PUR')
              ) {
                <div class="row">
                  <div class="col col-md-12">
                    <pr-input-radio
                      formControlName="crowdfundingNominatifPur"
                      direction="column"
                      [isDefault]="false"
                      columns="2"
                      [options]="crowdfundingNominatifPurOptions"
                      label="Souscription Nominatif Administré ou Pur"
                    >
                    </pr-input-radio>
                  </div>
                </div>
              }
              @if (
                getAdditionalQuestions(
                  parameters,
                  'CROWDFUNDING_NOMINATIF_PUR'
                ) &&
                product?.get('parameters').get('crowdfundingNominatifPur')
                  ?.value == 'ADMINISTRED'
              ) {
                <div class="row">
                  <div class="col col-md-12">
                    <pr-input-radio
                      formControlName="crowdfundingNominatifAdministredOption"
                      direction="column"
                      [isDefault]="false"
                      columns="2"
                      [options]="crowdfundingNominatifAdministredOptions"
                      label="Choix option souscription nominatif administré"
                    >
                    </pr-input-radio>
                  </div>
                </div>
              }
              @if (
                getAdditionalQuestions(
                  parameters,
                  'CROWDFUNDING_INSIGHT_CHOICE'
                )
              ) {
                <div class="row">
                  <div class="col col-md-12">
                    <pr-input-radio
                      formControlName="crowdfundingInsightChoice"
                      direction="column"
                      [isDefault]="false"
                      columns="2"
                      [options]="crowdfundingInsightOptions"
                      label="Choix option de part"
                    >
                    </pr-input-radio>
                  </div>
                </div>
              }
            </ng-container>
          </ng-container>
        }
      }
    </ng-container>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
